
import React from "react";
import { ModernActionBar } from "./components/ModernActionBar";
import { ModernContentGrid } from "./components/ModernContentGrid";
import { AmpDocumentsSection } from "@/components/AMP/AmpDocumentsSection";

import { Assessment as BaseAssessment } from "../types";
import { Assessment as FolderContentsAssessment } from "./types.d";
import type { Database } from "@/integrations/supabase/types";

type Folder = Database['public']['Tables']['folders']['Row'];

interface FolderDisplaySectionProps {
  folderData: Folder;
  subfolders: Folder[];
  assessments: BaseAssessment[];
  projectId: string;
  folderId: string;
  isShared: boolean;
  onOpenFolder: (folderId: string) => void;
  onStartAssessment: (projectId: string, folderId: string) => void;
  onNavigateToAssessment: (assessmentId: string, folderId: string) => void;
  onCreateFolder: (name: string, description?: string) => Promise<void>;
  onDeleteFolder: (folderId: string) => Promise<void>;
  onDeleteAssessment: (assessmentId: string) => Promise<void>;
  onFolderUpdated?: () => void;
  onRefresh?: () => void;
}

export const FolderDisplaySection: React.FC<FolderDisplaySectionProps> = ({
  folderData,
  subfolders,
  assessments,
  projectId,
  folderId,
  isShared,
  onOpenFolder,
  onStartAssessment,
  onNavigateToAssessment,
  onCreateFolder,
  onDeleteFolder,
  onDeleteAssessment,
  onFolderUpdated,
  onRefresh
}) => {
  // Convert Assessment[] to FolderContentsAssessment[] format - PRESERVE ORIGINAL TYPE
  const convertedAssessments: FolderContentsAssessment[] = assessments.map(assessment => ({
    ...assessment,
    description: assessment.description || "", // Ensure description is never undefined
    created_at: assessment.created_at || new Date().toISOString(), // Ensure created_at is always present
    updated_at: assessment.updated_at || new Date().toISOString(), // Ensure updated_at is always present
    data: assessment.data || null, // Ensure data is always present
    type: assessment.type // ✅ PRESERVE ORIGINAL TYPE - DO NOT HARDCODE
  }));

  return (
    <div className="space-y-6">
      <AmpDocumentsSection projectId={projectId} folderId={folderId} />

      <div className="flex items-center gap-4 pt-4">
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground whitespace-nowrap">
          Verktyg och innehåll
        </span>
        <div className="h-px flex-1 bg-border/60" />
      </div>

      <ModernActionBar

        projectId={projectId}
        folderId={folderId}
        isShared={isShared}
        onStartAssessment={onStartAssessment}
        onCreateFolder={onCreateFolder}
        onRefresh={onRefresh}
      />


      <ModernContentGrid
        folderData={folderData}
        subfolders={subfolders}
        assessments={convertedAssessments}
        projectId={projectId}
        folderId={folderId}
        isShared={isShared}
        onOpenFolder={onOpenFolder}
        onNavigateToAssessment={onNavigateToAssessment}
        onDeleteFolder={onDeleteFolder}
        onDeleteAssessment={onDeleteAssessment}
        onCreateFolder={onCreateFolder}
        onStartAssessment={onStartAssessment}
        onRefresh={onRefresh}
      />

    </div>
  );
};
